import React from 'react';
import './Testimonials.css';

const Testimonials = () => {
  return (
    <section className="testimonials-section">
      <div className="container">
        <h2 className="section-title">What Businesses Say</h2>
        <div className="testimonial-content">
          <div className="testimonial-video">
            <div className="video-placeholder">
              <button className="play-button">▶</button>
            </div>
          </div>
          <div className="testimonial-quote">
            <p className="quote-text">
              "This platform has transformed how we manage our operations. 
              The efficiency gains have been remarkable."
            </p>
            <div className="quote-author">
              <p className="author-name">John Smith</p>
              <p className="author-title">CEO, Company Name</p>
            </div>
          </div>
          <div className="testimonial-dots">
            <span className="dot active"></span>
            <span className="dot"></span>
            <span className="dot"></span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;

